export default __webpack_public_path__ + "media/outlineBackground.45463ec4.svg";